import React, { useEffect, useState } from 'react';
import {
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
  Box,
  Container,
  Skeleton, // Skeleton をインポート
} from '@mui/material';
import { Link } from 'react-router-dom';
import { collection, getDocs, getFirestore } from 'firebase/firestore';
import app from './firebase';


const db = getFirestore(app);

const OfficialRewards = () => {
  const [rewards, setRewards] = useState([]);
  const [loading, setLoading] = useState(true); // ローディング状態を管理

  useEffect(() => {
    const fetchRewards = async () => {
      try {
        // "official-rewards" コレクションから全ドキュメントを取得
        const querySnapshot = await getDocs(collection(db, 'official-rewards'));
        // 各ドキュメントの id とデータを含むオブジェクトに変換
        const rewardsList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setRewards(rewardsList);
      } catch (error) {
        console.error('Error fetching rewards:', error);
      } finally {
        setLoading(false); // 読み込み完了後に false に設定
      }
    };

    fetchRewards();
  }, []);

  return (
    <Container
      maxWidth="lg"
      sx={{
        backgroundColor: "#121212",
        py: 4,
        minHeight: "100vh",
      }}
    >
      <Grid container spacing={4}>
        {loading ? (
          // ロード中は Skeleton を表示（例として6件分）
          Array.from(new Array(6)).map((_, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Skeleton 
                sx={{ borderRadius: 2 }}
                variant="rectangular" 
                height={300} 
                animation="wave" 
              />
            </Grid>
          ))
        ) : (
          rewards.map((item) => (
            <Grid item xs={12} md={4} key={item.id}>
              <Card
                component={Link} // Card をリンク化
                to={`/reward/${item.id}`} // ルーティング先は必要に応じて変更
                sx={{
                  position: "relative", // 内部要素の絶対配置用
                  display: "flex",
                  flexDirection: "column",
                  background: "linear-gradient(135deg, #1e1e1e, #292929)",
                  color: "#fff",
                  boxShadow: "0 0 10px rgba(144, 202, 249, 0.5)",
                  borderRadius: 2,
                  border: "1px solid rgba(144, 202, 249, 0.5)",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  "&:hover": {
                    transform: "scale(1.03)",
                    boxShadow: "0 0 20px rgba(144, 202, 249, 0.8)",
                  },
                  textDecoration: "none", // リンクの下線を消す
                }}
              >
                {/* label が存在する場合は右上に表示 */}
                {item.label && (
                  <Typography
                    variant="caption"
                    sx={{
                      position: 'absolute',
                      top: 8,
                      right: 8,
                      backgroundColor:
                        item.label.toLowerCase() === 'audit'
                          ? 'rgba(244, 143, 177, 0.7)' // audit → 半透明ピンク
                          : item.label.toLowerCase() === 'vote'
                          ? 'rgba(102, 187, 106, 0.7)' // vote → 半透明緑
                          : 'rgba(0, 0, 0, 0.5)', // その他はデフォルト（半透明）
                      padding: '4px 8px',
                      borderRadius: '4px',
                      color: '#fff',
                      fontFamily: "Orbitron, sans-serif",
                      zIndex: 1,
                    }}
                  >
                    {item.label}
                  </Typography>
                )}
                <CardMedia
                  component="img"
                  height="180"
                  image={item.thumbnail}
                  alt={item.title}
                />
                <CardContent sx={{ flexGrow: 1 }}>
                  {/* タイトル：1行に制限 */}
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    sx={{
                      color: "#90caf9",
                      fontFamily: "Orbitron, sans-serif",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {item.title}
                  </Typography>
                  {/* 説明文：3行に制限 */}
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#bbb",
                      fontFamily: "Orbitron, sans-serif",
                      display: "-webkit-box",
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {item.desc}
                  </Typography>
                  <Box mt={2}>
                    <Typography
                      variant="h6"
                      sx={{ color: "#f48fb1", fontFamily: "Orbitron, sans-serif" }}
                    >
                      Reward: {new Intl.NumberFormat('en-US').format(item.reward)} $EMCII
                    </Typography>
                    {/* 有効期限の表示（存在する場合） */}
                    {item.expiration && (
                      <Typography
                        variant="body2"
                        sx={{ color: "#bbb", fontFamily: "Orbitron, sans-serif", mt: 1 }}
                      >
                        Expiration: {
                          // Firestore の Timestamp 型の場合は seconds を使って変換
                          item.expiration.seconds
                            ? new Date(item.expiration.seconds * 1000).toLocaleDateString()
                            : new Date(item.expiration).toLocaleDateString()
                        }
                      </Typography>
                    )}
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))
        )}
      </Grid>
    </Container>
  );
};

export default OfficialRewards;
